import React from "react"

import PersonCard from "components/card/person"
import PersonNestedCard from "components/card/person/person-image-card"

const ContentfulPersonCard = ({ component, hideIdentity, isNested, isHomePage }) => {
  const { id, name, personTitle, image, siteUrl, shortBio, credentials } = component

  if (isNested && isHomePage) {
    return (
      <PersonNestedCard
        key={id}
        name={name}
        description={personTitle}
        imageUrl={image && image[0]?.secure_url}
        link={siteUrl}
        hideIdentity={hideIdentity}
        shortBio={shortBio}
        credentials={credentials}
        title={personTitle}
      />
    )
  }

  return (
    <PersonCard
      key={id}
      name={name}
      description={personTitle}
      imageUrl={image && image[0]?.secure_url}
      link={siteUrl}
      hideIdentity={hideIdentity}
      credentials={credentials}
    />
  )
}

export default ContentfulPersonCard
